import { gql } from '@apollo/client';

export const DELETE_TEMPLATE = gql`
  mutation DeleteTemplate($id: ID!) {
    template: deleteTemplate(id: $id) {
      id
      name
    }
  }
`;
